import { GET_BUSINESS_FUNCTION_LIST } from '@nile/itsm/src/graphql';
import { AccountClient } from '@nile/graphql';
import { GET_CLIENT_SITE_LIST_FOR_DROPDOWN_WO_ACCOUNT } from '@nile/banyan/src/Graphql/Mutations/site';
import { GET_ALL_CLIENT_DATA } from '../dromo';
import { COMMON_CONSTANTS } from '@nile/components';

import { getValidators } from '../utils/helpers';

export const getAssetImportFields = (currentProduct) => {
  const assetFields = [
    {
      label: 'common.asset',
      key: 'name',
      type: 'string',
      validators: [
        {
          validate: 'required',
          errorMessage: 'dromo.validation.requiredField'
        }
      ]
    }
  ];
  if (currentProduct === COMMON_CONSTANTS.MSP) {
    assetFields.push(
      {
        label: 'common.client',
        key: 'clientName',
        type: 'select',
        selectOptions: [],
        validators: [
          {
            validate: 'required',
            errorMessage: 'dromo.validation.requiredField'
          }
        ]
      },
      {
        label: 'common.site',
        key: 'siteName',
        type: 'select',
        selectOptions: [],
        validators: [
          {
            validate: 'required',
            errorMessage: 'dromo.validation.requiredField'
          }
        ]
      }
    );
  } else if (currentProduct === COMMON_CONSTANTS.IT) {
    assetFields.push(
      {
        label: 'common.site',
        key: 'siteName',
        type: 'select',
        selectOptions: [],
        validators: [
          {
            validate: 'required',
            errorMessage: 'dromo.validation.requiredField'
          }
        ]
      },
      {
        label: 'common.department',
        key: 'departmentName',
        type: 'select',
        selectOptions: []
      }
    );
  }
  assetFields.push({
    label: 'entityAttribute.requester.email',
    key: 'requesterEmail',
    type: 'string',
    validators: [
      {
        validate: 'regex_match',
        // prettier-ignore
        regex: '^([a-zA-Z0-9_+\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$',
        errorMessage: 'domain.validation.emailAddress'
      }
    ]
  });
  return assetFields;
};

export const getAssetValidators = (customField) => {
  switch (customField?.columnName) {
    case 'ticketType':
    case 'status':
      return [
        {
          validate: 'required',
          errorMessage: 'dromo.validation.requiredField'
        }
      ];
      break;
    default:
      return getValidators(customField);
  }
};

export const getClient = (field) => {
  return AccountClient;
};

export const getVariables = (field) => {
  switch (field) {
    case 'siteName':
      return {
        input: {
          sort: [
            {
              attribute: 'name',
              order: 'ASC'
            }
          ]
        }
      };
    case 'clientName':
      return {
        listInfo: {
          sort: {
            attribute: 'name',
            order: 'ASC'
          }
        }
      };
    default:
      return undefined;
  }
};

export const getQuery = (field) => {
  switch (field) {
    case 'departmentName':
      return GET_BUSINESS_FUNCTION_LIST;
    case 'siteName':
      return GET_CLIENT_SITE_LIST_FOR_DROPDOWN_WO_ACCOUNT;
    case 'clientName':
      return GET_ALL_CLIENT_DATA;
    default:
      return null;
  }
};

export const callQuery = (field) => {
  const query = getQuery(field);
  const client = getClient(field);
  const variables = getVariables(field);

  switch (field) {
    case 'departmentName':
      return client?.query({ query });
    case 'siteName':
      return client?.query({ query, variables });
    case 'clientName':
      return client?.query({ query, variables });
    default:
      return [];
  }
};

const getQueryName = (field) => {
  switch (field) {
    case 'departmentName':
      return 'getBusinessFunctionList';
    case 'siteName':
      return 'getClientSiteList';
    case 'clientName':
      return 'getClientList';
    default:
      return '';
  }
};

export const shapeOptions = (field, options) => {
  const key = getQueryName(field);
  switch (field) {
    case 'departmentName':
      return options?.data?.[key].map((el) => {
        return {
          value: `${el.businessFunctionId}`,
          label: `${el.name}`
        };
      });
    case 'siteName':
      return options?.data?.[key].sites
        .map((el) => {
          return {
            value: `${el.name}`,
            label: `${el.name}`
          };
        })
        .filter((el) => el.value?.trim() !== '');
    case 'clientName':
      return options?.data?.[key].clients.map((el) => {
        return {
          value: `${el.name}`,
          label: `${el.name}`
        };
      });
    default:
      return options;
  }
};
